/**
 * Whether the learner "not cleared" tooltip should be disabled (hidden) for a given cleared status.
 *
 * The tooltip communicates that a learner is not cleared for a program, so it is shown only when
 * the status is explicitly `false`. A cleared learner (`true`) or an unknown status
 * (`null`/`undefined`) disables it.
 *
 * @param {boolean | null | undefined} cleared The learner's cleared status.
 *
 * @returns {boolean} Whether the not-cleared tooltip should be disabled.
 */
export const isLearnerNotClearedTooltipDisabled = (cleared: boolean | null | undefined): boolean =>
  cleared !== false;
